<template lang="pug">
payment-order-block-form 
  app-select( v-model="form.sber" label="Банковское приложение" hideDetails dense :items="bankTypeList" item-text="title" item-value="value" :menu-props="menuProps" @input="handleInputForm" :rules="[rules.number]" )
  app-text-field( v-model="form.payer" label="ФИО плательщика" hideDetails dense @input="handleInputForm" :rules="[rules.required]" )
</template>

<script>
import { BankType } from '../../../models/payment.order.form.models';
import PaymentOrderBlockForm from './PaymentOrderBlockForm.vue';
import { $_validate_rules } from '@/common/ValidateRules'

export default {
  mixins: [ $_validate_rules ],

  components: {
    PaymentOrderBlockForm
  },

  props: {
    form: null
  },

  data() {
    return {
      menuProps: {
        bottom: true, offsetY: true, light: true
      }
    }
  },

  computed: {
    bankTypeList() {
      return Object.values(BankType)
    }
  },

  methods: {
    handleInputForm() {
      this.$emit('formChanged')
    }
  }
}
</script>